module.exports = __webpack_public_path__ + "img/Go-Forward-sm.9a0e30e2.svg";